<template>
  <table
    @mousemove="handleMouseEnter"
    @click="handleYearTableClick"
    class="el-year-table date-picker3">
    <tbody>
      <tr>
        <td class="available" :class="getCellStyle(startYear + 0)">
          <a class="cell">{{ startYear }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 1)">
          <a class="cell">{{ startYear + 1 }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 2)">
          <a class="cell">{{ startYear + 2 }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 3)">
          <a class="cell">{{ startYear + 3 }}</a>
        </td>
      </tr>
      <tr>
        <td class="available" :class="getCellStyle(startYear + 4)">
          <a class="cell">{{ startYear + 4 }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 5)">
          <a class="cell">{{ startYear + 5 }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 6)">
          <a class="cell">{{ startYear + 6 }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 7)">
          <a class="cell">{{ startYear + 7 }}</a>
        </td>
      </tr>
      <tr>
        <td class="available" :class="getCellStyle(startYear + 8)">
          <a class="cell">{{ startYear + 8 }}</a>
        </td>
        <td class="available" :class="getCellStyle(startYear + 9)">
          <a class="cell">{{ startYear + 9 }}</a>
        </td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>
</template>

<script type="text/babel">
import { hasClass } from 'element-ui/lib/utils/dom'
import { isDate, range, nextDate, getDayCountOfYear } from '../util'
import { arrayFindIndex, coerceTruthyValueToArray } from 'element-ui/lib/utils/util'
import '../style/year-table.scss'

const datesInYear = year => {
  const numOfDays = getDayCountOfYear(year)
  const firstDay = new Date(year, 0, 1)
  return range(numOfDays).map(n => nextDate(firstDay, n))
}

export default {
  props: {
    disabledDate: {},
    value: {},
    defaultValue: {
      validator(val) {
        // null or valid Date Object
        return val === null || (val instanceof Date && isDate(val))
      }
    },
    date: {},
    minDate: {},
    maxDate: {},
    activeInputIndex: Number,
    singleValue: Boolean
  },

  computed: {
    startYear() {
      return Math.floor(this.date.getFullYear() / 10) * 10
    }
  },

  methods: {
    getCellStyle(year) {
      const style = {}
      const today = new Date()
      const activeInputIndex = this.activeInputIndex
      let disabled = typeof this.disabledDate === 'function' ? datesInYear(year).every(this.disabledDate) : false
      let _value = Array.isArray(this.value) ? this.value.map(v => isDate(v) ? new Date(v) : null) : this.value
      let current = _value
      if (!disabled) {
        // 结束时间不允许大于开始时间
        if (activeInputIndex === 1) {
          if (!this.singleValue && this.minDate) {
            disabled = datesInYear(year).every(i => this.minDate.getTime() > i.getTime())
          }
          // 单边值情况下，如果只有只有一个值情况下，minDate maxDate 都为空
          if (this.singleValue && _value[0]) {
            disabled = datesInYear(year).every(i => new Date(_value[0]).getTime() > i.getTime())
          }
          current = Array.isArray(this.value) ? (this.maxDate || _value[1]) : this.value
        }

        // 开始时间不允许大于结束时间
        if (activeInputIndex === 0) {
          if (!this.singleValue && this.maxDate) {
            disabled = datesInYear(year).every(i => this.maxDate.getTime() < i.getTime())
          }
          // 单边值情况下，如果只有只有一个值情况下，minDate maxDate 都为空
          if (this.singleValue && _value[1]) {
            disabled = datesInYear(year).every(i => new Date(_value[1]).getTime() < i.getTime())
          }
          current = Array.isArray(this.value) ? (this.minDate || _value[0]) : this.value
        }
      }
      style.disabled = disabled
      style.current = arrayFindIndex(coerceTruthyValueToArray(current), date => date.getFullYear() === year) >= 0
      style.today = today.getFullYear() === year
      style.default = this.defaultValue && this.defaultValue.getFullYear() === year

      return style
    },

    handleYearTableClick(event) {
      const target = event.target
      if (target.tagName === 'A') {
        if (hasClass(target.parentNode, 'disabled')) return
        const year = target.textContent || target.innerText
        this.$emit('pick', Number(year))
      }
    },

    handleMouseEnter(event) {
      let target = event.target
      if (target.tagName === 'A') {
        const year = target.textContent || target.innerText
        const params = {
          newDate: year,
          event
        }
        this.$parent.handleDateMouseEnter && this.$parent.handleDateMouseEnter(params)
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker3/src/basic/year-table.vue